import React from "react";
import { SmartImage } from "@/src/components/v2/SmartImage/SmartImage";
import Container from "@/src/components/atoms/Container/Container";
import Badge from "../../atoms/Badge";
import LabelAndStars from "../../molecules/LabelAndStars";
import FactoidWithIcon from "../../molecules/FactoidWithIcon";
import HeightIcon from "../../../images/icons/color/height-icon.svg";
import WeightIcon from "../../../images/icons/color/weight-icon.svg";
import LifeSpanIcon from "../../../images/icons/color/life-span-icon.svg";

export type IBreedHero = {
    name: string;
    description: string;
    imageURL?: string;
    traits: string[];
    healthRating: number;
    personalityRating: number;
    careRating: number;
    height: string[];
    weight: string[];
    lifespan: string[];
};

const BreedHero = (props: IBreedHero) => {
    return (
        <Container>
            <div className="BreedHero overflow-hidden rounded-3xl shadow-lg md:flex md:flex-row-reverse">
                <div className="BreedHero-image relative h-[0px] pb-[77%] md:h-auto md:w-1/2 md:pb-[0px]">
                    {props.imageURL && (
                        // SmartImage, not raw next/image: `priority` alone no longer sets fetchpriority in Next 15, and the
                        // wrapper adds fetchPriority="high" for the LCP hero (ENG-19521). Same sizes as before.
                        <SmartImage
                            image={props.imageURL}
                            alt={props.name}
                            priority
                            fill
                            mobileViewWidthPercent={100}
                            desktopViewWidthPercent={30}
                            objectFit="cover"
                            objectPosition="center"
                        />
                    )}
                </div>
                <div className="BreedHero-content bg-background-contrast p-6 text-text-contrast md:w-1/2 lg:p-8">
                    <h1 className="BreedHero-title text-md font-bold tracking-md lg:text-xl lg:tracking-xl">{props.name}</h1>
                    <div className="BreedHero-tags flex flex-wrap items-center gap-3 py-3 lg:py-4">
                        {props.traits &&
                            props.traits.map((trait, index) => (
                                <Badge variant="contrast" key={trait + index}>
                                    {trait}
                                </Badge>
                            ))}
                    </div>
                    <p className="BreedHero-description text-caption tracking-caption lg:text-body2 lg:tracking-body2">{props.description}</p>
                    <div className="BreedHero-stats mt-6 grid grid-cols-2 gap-4 lg:grid-cols-3 2xl:grid-cols-4">
                        <LabelAndStars title="Health" starCount={props.healthRating as any} />
                        <LabelAndStars title="Personality" starCount={props.personalityRating as any} />
                        <LabelAndStars title="Lifetime Care" starCount={props.careRating as any} />
                    </div>

                    <div className="BreedHero-stats mt-6 grid grid-cols-2 gap-4 lg:grid-cols-3 2xl:grid-cols-4">
                        <p className="tet-info-light mb-2 text-overline font-bold uppercase tracking-overline">Breed Profile</p>
                    </div>
                    <div className="BreedHero-stats flex flex-row flex-wrap gap-4">
                        <FactoidWithIcon title="Height" value={props.height} unitName="Inches" image={HeightIcon} />
                        <FactoidWithIcon title="Weight" value={props.weight} unitName="Pounds" image={WeightIcon} />
                        <FactoidWithIcon title="Life Span" value={props.lifespan} unitName="Years" image={LifeSpanIcon} />
                    </div>
                </div>
            </div>
        </Container>
    );
};

export default BreedHero;
